export default (id = null) => ({
  id,
  type: 'content',
  text: '\n',
  properties: '\n',
  discussions: {},
  comments: {},
  hash: 0,
});



// WEBPACK FOOTER //
// ./src/data/empties/emptyContent.js